/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Configure_Hub_Emailtemplate_Subtitle2Inputs */

const en_coinvestments_configure_hub_emailtemplate_subtitle2 = /** @type {(inputs: Coinvestments_Configure_Hub_Emailtemplate_Subtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set the subject, body and attachments for this deal's outreach emails`)
};

/**
* | output |
* | --- |
* | "Set the subject, body and attachments for this deal's outreach emails" |
*
* @param {Coinvestments_Configure_Hub_Emailtemplate_Subtitle2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_configure_hub_emailtemplate_subtitle2 = /** @type {((inputs?: Coinvestments_Configure_Hub_Emailtemplate_Subtitle2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Configure_Hub_Emailtemplate_Subtitle2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_configure_hub_emailtemplate_subtitle2(inputs)
});
export { coinvestments_configure_hub_emailtemplate_subtitle2 as "coInvestments_configure_hub_emailTemplate_subtitle" }